var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-datetime"},[_c('el-date-picker',{attrs:{"type":_vm.compType,"placeholder":_vm.placeholder,"value-format":_vm.format,"picker-options":_vm.pickerOptions},on:{"focus":_vm.focusHandle},model:{value:(_vm.valueData),callback:function ($$v) {_vm.valueData=$$v},expression:"valueData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }